import { render } from "./AvatarsSlider.vue?vue&type=template&id=78d21248&scoped=true"
import script from "./AvatarsSlider.vue?vue&type=script&lang=js"
export * from "./AvatarsSlider.vue?vue&type=script&lang=js"

import "./AvatarsSlider.vue?vue&type=style&index=0&id=78d21248&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d21248"]])

export default __exports__